import { AppThunk } from '../../../store/types';
import { addSendError, setSendStatus } from '../../../store/order/policy/finalizePoliciesSlice';
import { getFinalizePoliciesDataAsync } from '../../../store/order/policy/getFinalizePoliciesDataAsync';
import { publishDocumentAsync } from '../documents/adminDocumentsAPI';
import { eDocumentVisibilityType } from '../../../types/order/documents/eDocumentVisibilityType';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';

export const publishDocumentsAsync =
  (orderId: string, documentIds: string[]): AppThunk =>
  async (dispatch) => {
    dispatch(setSendStatus(createFetchInProgress()));
    const responses = await Promise.all(
      documentIds.map((id) => publishDocumentAsync(id, eDocumentVisibilityType.Client))
    );
    const errors = responses.filter((response) => response instanceof Error);
    if (errors.length) {
      errors.forEach((error) => addSendError(error));
      dispatch(setSendStatus(createFetchedWithError()));
    } else {
      dispatch(getFinalizePoliciesDataAsync(orderId));
      dispatch(setSendStatus(createFetchedSuccess()));
    }
  };
